// extracted by mini-css-extract-plugin
module.exports = {"addCompDisp":"styles_addCompDisp__158tB","newThemeButton":"styles_newThemeButton__Smbvk"};